import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    messages : [],
}

export const messageSlice = createSlice({
  name: 'messages',
  initialState,
  reducers: {
  
  messages :(state,action)=>{
    state.messages = action.payload
  }
 
},
})
export const {messages} = messageSlice.actions

export default messageSlice.reducer